import { render, staticRenderFns } from "./selectDefaultPage.vue?vue&type=template&id=2bacd1ac&"
import script from "./selectDefaultPage.vue?vue&type=script&lang=js&"
export * from "./selectDefaultPage.vue?vue&type=script&lang=js&"
import style0 from "./selectDefaultPage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports